import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import "./PersonalDetails.css";
import { baseUrl, convertDateToWords, convertDateToMarathi, } from "../../../Utility/constants";
import { toast } from "react-toastify";
import { getSchoolId } from "../../../Utility/commonFunctions";

const EditPersonalDetailsModal = ({
  show,
  handleClose,
  handleSubmit,
  editItem,
  setEditItem,
  adminSchoolId
}) => {
  const role = localStorage.getItem("Role");
  const [religions, setReligions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [castes, setCastes] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const [states, setStates] = useState([]);
  const [motherTongue, setMotherTongue] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [cities, setCities] = useState([]);
  const [actualHeight, setActualHeight] = useState('');
  const [schoolDetails, setSchoolDetails] = useState({});
  const heightRef = useRef(null);
  const [sessionList, setSessionList] = useState([]);
  const [genderMaster, setGenderMaster] = useState([]);
  const [disabilityTypes, setDisabilityTypes] = useState([]);
  const [enableDisabilityType, setEnableDisabilityType] = useState(true);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
debugger;
    // Personal Details
    if (!editItem.firstName) newErrors.firstName = "First Name is required.";
    if (!editItem.lastName) newErrors.lastName = "Last Name is required.";
    if (!editItem.gender) newErrors.gender = "Gender is required.";
    if (!editItem.dateOfBirth) newErrors.dateOfBirth = "Date of Birth is required.";
    if (!editItem.religionId) newErrors.religionId = "Religion is required.";
    if (!editItem.categoryId) newErrors.categoryId = "Category is required.";
    if (!editItem.casteId) newErrors.casteId = "Caste is required.";
    if (!editItem.motherTongue) newErrors.motherTongue = "Mother Tongue is required.";
    if (!editItem.birthPlace) newErrors.birthPlace = "Place of Birth is required.";
    if (!editItem.bloodGroupId) newErrors.bloodGroupId = "Blood Group is required.";
    if (!editItem.heightInCm) newErrors.heightInCm = "Height is required.";
    if (!editItem.weightInKg) newErrors.weightInKg = "Weight is required.";
    if (!editItem.uidNo || editItem.uidNo.length !== 12) newErrors.uidNo = "Valid Aadhaar No is required (12 digits).";
    if (!editItem.nameAsPerAadhaar) newErrors.nameAsPerAadhaar = "Name As Per Aadhaar is required.";

    // Contact Details
    if (!editItem.studentContactNumber || editItem.studentContactNumber.length !== 10)
      newErrors.studentContactNumber = "Valid Student Contact Number is required (10 digits).";
    if (!editItem.stateId) newErrors.stateId = "State is required.";
    if (!editItem.districtId) newErrors.districtId = "District is required.";
    if (!editItem.talukaId) newErrors.talukaId = "Taluka is required.";
    if (!editItem.cityVillageId) newErrors.cityVillageId = "City is required.";
    if (!editItem.address) newErrors.address = "Address is required.";
    if (!editItem.pincode || editItem.pincode.length !== 6) newErrors.pincode = "Valid Pincode is required (6 digits).";
    if (!editItem.studentEmail) newErrors.studentEmail = "Email ID is required.";

    // Father
    //if (!editItem.fatherFullName) newErrors.fatherFullName = "Father's Name is required.";
    if (editItem.parentContactNumber && editItem.parentContactNumber.length !== 10)
      newErrors.parentContactNumber = "Valid Contact Number is required (10 digits).";
    //if (!editItem.parentEmail) newErrors.parentEmail = "Email ID is required.";
    if (editItem.parentAadhaarNo && editItem.parentAadhaarNo.length !== 12)
      newErrors.parentAadhaarNo = "Valid Aadhaar No is required (12 digits).";
    // if (!editItem.parentOccupation) newErrors.parentOccupation = "Occupation is required.";
    // if (!editItem.parentHighestQualification) newErrors.parentHighestQualification = "Qualification is required.";

    // Mother
    if (!editItem.motherFullName) newErrors.motherFullName = "Mother's Name is required.";
    if (editItem.motherContactNumber && editItem.motherContactNumber.length !== 10)
      newErrors.motherContactNumber = "Valid Contact Number is required (10 digits).";
    //if (!editItem.motherEmail) newErrors.motherEmail = "Email ID is required.";
    if (editItem.motherAadhaarNo &&  editItem.motherAadhaarNo.length !== 12)
      newErrors.motherAadhaarNo = "Valid Aadhaar No is required (12 digits).";
    //if (editItem.motherOccupation) newErrors.motherOccupation = "Occupation is required.";
    //if (!editItem.motherHighestQualification) newErrors.motherHighestQualification = "Qualification is required.";

    // Guardian
    if (editItem.guardianContactNumber && editItem.guardianContactNumber.length !== 10)
      newErrors.guardianContactNumber = "Valid Contact Number is required (10 digits).";  
    if (editItem.guardianAadhaarNo && editItem.guardianAadhaarNo.length !== 12)
      newErrors.guardianAadhaarNo = "Valid Aadhaar No is required (12 digits).";

    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // Fetch gender details
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/CommonMaster/GetGenderMasters`)
      .then((response) => {
        setGenderMaster(response.data);
      })
      .catch((error) => {
        console.log("Failed to load school details.");
      });
  }, []);

  useEffect(() => {
    const loadSchoolSession = async () => {
      try {
        const school_Id = await getSchoolId();

        const response = await axios.get(
          `${baseUrl}/api/SchoolGeneralInfo/GetSchoolBySession?schoolId=${school_Id}`
        );

        setSessionList(response.data);
      } catch (error) {
        console.log("Failed to load school details.", error);
      }
    };

    loadSchoolSession();
  }, []);

  useEffect(() => {
    if (editItem?.casteId) {
      fetchCategories(editItem.casteId);
    } else {
      setCategories([]);
    }
  }, [editItem?.casteId]);

  const fetchDropdownData = async () => {
    try {
      const [
        religionsResponse,
        //categoriesResponse,
        castesResponse,
        bloodGroupsResponse,
        statesResponse,
        motherTongueResponse,
        schoolDetailsResponse,
        disablityResponse,
      ] = await Promise.all([
        axios.get(`${baseUrl}/api/CommonMaster/GetReligionMasters`),
        //axios.get(`${baseUrl}/api/CategoryMaster`),
        axios.get(`${baseUrl}/api/CasteMaster`),
        axios.get(`${baseUrl}/api/CommonMaster/GetBloodGroupMasters`),
        axios.get(`${baseUrl}/api/StateMaster`),
        axios.get(`${baseUrl}/api/CommonMaster/GetMotherTongueMasters`),
        axios.get(`${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${editItem.schoolId}`),
        axios.get(`${baseUrl}/api/DisabilityTypesMaster`),
      ]);

      setReligions(religionsResponse.data);
      //setCategories(categoriesResponse.data);
      setCastes(castesResponse.data);
      setBloodGroups(bloodGroupsResponse.data);
      setStates(statesResponse.data);
      setMotherTongue(motherTongueResponse.data);
      setSchoolDetails(schoolDetailsResponse.data);
      setDisabilityTypes(disablityResponse.data);


      //if (editItem.categoryId) fetchCastes(editItem.categoryId);
      if (editItem.stateId) fetchDistricts(editItem.stateId);
      if (editItem.districtId) fetchTalukas(editItem.districtId);
      if (editItem.talukaId) fetchCities(editItem.talukaId);
    } catch (error) {
      console.error("Error fetching dropdown data", error);
    }
  };

  const fetchCategories = async (casteId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/CategoryMaster/GetCategoryMasterByCaste?CasteID=${casteId}`
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching Castes", error);
    }
  };

  const fetchDistricts = async (stateId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/DistrictMaster/GetDistrictByState?id=${stateId}`
      );
      setDistricts(response.data);
    } catch (error) {
      console.error("Error fetching districts", error);
    }
  };

  const fetchTalukas = async (districtId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/TalukaMaster/GetTalukaByDistrict?id=${districtId}`
      );
      setTalukas(response.data);
    } catch (error) {
      console.error("Error fetching talukas", error);
    }
  };

  const fetchCities = async (talukaId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/CityVillageMaster/GetCityVillageBtTaluka?id=${talukaId}`
      );
      setCities(response.data);
    } catch (error) {
      console.error("Error fetching cities", error);
    }
  };

  useEffect(() => {
    if (editItem && editItem.disability !== undefined) {
      setEnableDisabilityType(!editItem.disability);
    }
  }, [editItem?.disability]);

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    //fetchCastes(categoryId);
    setEditItem((prev) => ({
      ...prev,
      categoryId: Number(e.target.value)
    }));
  };

  const handleCasteChange = (e) => {
    const casteId = e.target.value;
    if (casteId) {
      fetchCategories(casteId);
      setEditItem((prev) => ({
        ...prev,
        casteId,
        categoryId: ""
      }));
    }
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    fetchDistricts(stateId);
    //setEditItem((prev) => ({ ...prev, stateId }));
    setEditItem((prev) => ({
      ...prev,
      stateId,
      districtId: "",
      talukaId: "",
      cityId: "",
    }));
    fetchDistricts(stateId);
  };

  const handleDistrictChange = (e) => {
    const districtId = e.target.value;
    fetchTalukas(districtId);
    setEditItem((prev) => ({
      ...prev,
      districtId,
      talukaId: "",
      cityId: "",
    }));
    fetchTalukas(districtId);
  };

  const handleTalukaChange = (e) => {
    const talukaId = e.target.value;
    fetchCities(talukaId);
    setEditItem((prev) => ({ ...prev, talukaId, cityId: "" }));
    fetchCities(talukaId);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'disability') {
      setEnableDisabilityType(!checked);
    }
    // Check if the dateOfBirth field is being updated
    if (name === "dateOfBirth") {
      // First, update the dateOfBirth
      setEditItem((prevState) => {
        const dateInWords = schoolDetails.schoolMedium.toLowerCase() === "marathi" ? convertDateToMarathi(value) : convertDateToWords(value); // Convert the date to words
        return {
          ...prevState,
          dateOfBirth: value,
          dateOfBirthInWords: dateInWords, // Immediately set dateOfBirthInWords
        };
      });
    } else {
      setEditItem((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  // Store initial value when user clicks on the input
  const handleHeightFocus = (e) => {
    heightRef.current = e.target.value;
  };

  const handleHeightBlur = (e) => {
    const { value } = e.target;
    const prevValue = heightRef.current;
    if (value !== prevValue) {
      setActualHeight(value);
      const heightInCm = parseFloat(value) * 30.48;
      setEditItem((prev) => ({
        ...prev,
        heightInCm: heightInCm.toFixed(2),
      }));
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="custom-modal-lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Personal Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {editItem && (
          <Form onSubmit={(e) => {
            e.preventDefault();
            const newErrors = validateForm();
            if (Object.keys(newErrors).length === 0) {
              handleSubmit(e);
            }
            else {
              Object.values(newErrors).forEach((err) => {
                toast.error(err);
              });
            }
          }}>
            <Row className="mb-3">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                      <h4>Students Personal Details</h4></td>
                  </tr>
                </tbody></table>
              <Col md={2}>
                <Form.Group controlId="formFirstName">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">First Name</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideFirstName"
                      checked={!!editItem.hideFirstName}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={editItem.firstName || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formMiddleName">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Middle Name</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideMiddleName"
                      checked={!!editItem.hideMiddleName}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="middleName"
                    value={editItem.middleName || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formLastName">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Last Name</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideLastName"
                      checked={!!editItem.hideLastName}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={editItem.lastName || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formLastName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={
                      editItem.firstName +
                      " " +
                      editItem.middleName +
                      " " +
                      editItem.lastName
                    }
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formgender">
                  <Form.Label>Gender <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="gender"
                    value={editItem.gender || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select gender</option>
                    {
                      genderMaster.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      ))
                    }

                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formDateOfBirth">
                  <Form.Label>Date of Birth <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="dateOfBirth"
                    value={
                      editItem.dateOfBirth
                        ? editItem.dateOfBirth.split("T")[0] // Split the API date string and take the first part (yyyy-MM-dd)
                        : ""
                    }
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={2}>
                <Form.Group controlId="formDateOfBirthInWords">
                  <Form.Label>Date of Birth in Words</Form.Label>
                  <Form.Control
                    type="text"
                    name="dateOfBirthInWords"
                    value={editItem.dateOfBirthInWords || ""}
                    onChange={handleInputChange}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formReligion">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Religion</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideReligion"
                      checked={!!editItem.hideReligion}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    as="select"
                    name="religionId"
                    value={editItem.religionId || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Religion</option>
                    {religions.map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formCaste">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Caste</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideCaste"
                      checked={!!editItem.hideCaste}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    as="select"
                    name="casteId"
                    value={editItem.casteId || ""}
                    onChange={handleCasteChange}
                  >
                    <option value="">Select Caste</option>
                    {[...castes]
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formCategory">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Category</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideCategory"
                      checked={!!editItem.hideCategory}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    as="select"
                    name="categoryId"
                    value={editItem.categoryId || ""}
                    onChange={handleCategoryChange}
                  >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formMotherTongue">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">MotherTongue</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideMotherTongue"
                      checked={!!editItem.hideMotherTongue}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    as="select"
                    name="motherTongue"
                    value={editItem.motherTongue || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Mother Tongue</option>
                    {motherTongue.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formBirthPlace">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">BirthPlace</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideBirthPlace"
                      checked={!!editItem.hideBirthPlace}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="birthPlace"
                    value={editItem.birthPlace || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={2}>
                <Form.Group controlId="formBloodGroup">
                  <Form.Label>Blood Group <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="bloodGroupId"
                    value={editItem.bloodGroupId || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Blood Group</option>
                    {bloodGroups.map((b) => (
                      <option key={b.id} value={b.id}>
                        {b.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formHeightInCm">
                  <Form.Label>Height (ft) <span style={{ color: 'red' }}>*</span> {actualHeight || ""}</Form.Label>
                  <Form.Control
                    type="text"
                    name="heightInCm"
                    value={editItem.heightInCm || ""}
                    onChange={handleInputChange}
                    onFocus={handleHeightFocus} // Store initial value
                    onBlur={handleHeightBlur} // Use onBlur instead of onChange
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formWeightInKg">
                  <Form.Label>Weight (kg) <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="weightInKg"
                    value={editItem.weightInKg || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formUIDNo">
                  <Form.Label>UID No (Aadhaar No) <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="uidNo"
                    value={editItem.uidNo || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    disabled
                    maxLength={12}
                    minLength={12}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formNameAsPerAadhaar">
                  <Form.Label>Name As Per Aadhaar <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="nameAsPerAadhaar"
                    value={editItem.nameAsPerAadhaar || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formSessionId">
                  <Form.Label>Session</Form.Label>
                  <Form.Control
                    as="select"
                    name="sessionId"
                    value={editItem.sessionId}
                    onChange={handleInputChange}
                    disabled={role === "STUDENT" ? true : false}
                  >
                    <option value="">Select Session</option>
                    {sessionList && sessionList.map((session) => (
                      <option key={session.sessionId} value={session.sessionId}>
                        {session.sessionName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2} style={{ display: "none" }}>
                <br></br>
                <Form.Group controlId="formEWS">
                  <Form.Check
                    type="checkbox"
                    name="ews"
                    //checked={editItem.EWS}
                    checked={!!editItem.ews}
                    onChange={handleInputChange}
                    label="EWS"
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <br></br>
                <Form.Group controlId="formDisability">
                  <Form.Check
                    type="checkbox"
                    name="disability"
                    checked={!!editItem.disability}
                    onChange={handleInputChange}
                    label="Disability"
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <br></br>
                <Form.Group controlId="formDisabilityType">
                  <Form.Label> Select Disability</Form.Label>
                  <Form.Control
                    as="select"
                    name="disabilityType"
                    value={editItem.disabilityType || ""}
                    onChange={handleInputChange}
                    disabled={enableDisabilityType}
                  >
                    <option value="">-- Select --</option>
                    {disabilityTypes.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.disabilityCode}-{s.disabilityName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formDisabilityPercentage">
                  <Form.Label className="mt-4">Disability Percentage</Form.Label>
                  <Form.Control
                    type="text"
                    name="disabilityPercentage"
                    value={editItem.disabilityPercentage || ""}
                    onChange={handleInputChange}
                    disabled={enableDisabilityType}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formNationality">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mt-4">Nationality</Form.Label>
                    <span style={{ color: 'red', marginTop: '1rem' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideNationality"
                      checked={!!editItem.hideNationality}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mt-4"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="nationality"
                    value={"INDIAN"}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                      <h4>Contact Details </h4></td>
                  </tr>
                </tbody></table>
              <Col md={2}>
                <Form.Group controlId="formStudentContactNumber">
                  <Form.Label>Student Contact Number <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="studentContactNumber"
                    value={editItem.studentContactNumber || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    maxLength={10}
                    minLength={10}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formState">
                  <Form.Label>State <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="stateId"
                    value={editItem.stateId || ""}
                    onChange={handleStateChange}
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formDistrict">
                  <Form.Label>District <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="districtId"
                    value={editItem.districtId || ""}
                    onChange={handleDistrictChange}
                  >
                    <option value="">Select District</option>
                    {districts.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formTaluka">
                  <Form.Label>Taluka <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="talukaId"
                    value={editItem.talukaId || ""}
                    onChange={handleTalukaChange}
                  >
                    <option value="">Select Taluka</option>
                    {talukas.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formCity">
                  <Form.Label>City <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    as="select"
                    name="cityVillageId"
                    value={editItem.cityVillageId || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select City</option>
                    {cities.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formAddress">
                  <Form.Label>Address <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={editItem.address || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formPincode">
                  <Form.Label>Pincode <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="pincode"
                    value={editItem.pincode || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formStudentEmail">
                  <Form.Label>Email <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="studentEmail"
                    value={editItem.studentEmail || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              {/* <Col md={2}>
                <Form.Group controlId="formStudentPassword">
                  <Form.Label>Student Password</Form.Label>
                  <Form.Control
                    type="text"
                    name="studentpassword"
                    value={editItem.password && "*******"}
                    disabled
                  />
                </Form.Group>
              </Col> */}
            </Row>

            <Row className="mb-3">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={8} class="text-start fw-bold text-white" style={{ backgroundColor: "black" }}>
                      <h4>Parent  Details </h4></td>
                  </tr>
                </tbody></table>
              <Col md={2}>
                <Form.Group controlId="formfatherFullName">
                  <Form.Label>Father's Full Name 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="fatherFullName"
                    value={editItem.fatherFullName || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formParentContactNumber">
                  <Form.Label>Contact Number 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="parentContactNumber"
                    value={editItem.parentContactNumber || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    maxLength={10}
                    minLength={10}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formParentEmail">
                  <Form.Label>Email ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="parentEmail"
                    value={editItem.parentEmail || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formParentOccupation">
                  <Form.Label>Occupation 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="parentOccupation"
                    value={editItem.parentOccupation || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formParentAadhaarNo">
                  <Form.Label>Aadhaar No 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="parentAadhaarNo"
                    value={editItem.parentAadhaarNo || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    maxLength={12}
                    minLength={12}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formParentHighestQualification">
                  <Form.Label>Highest Qualification 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="parentHighestQualification"
                    value={editItem.parentHighestQualification || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formMotherFullName">
                  <div className="d-flex align-items-center gap-3">
                    <Form.Label className="mb-0">Mother's Full Name</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Form.Check
                      type="checkbox"
                      name="hideMotherName"
                      checked={!!editItem.hideMotherName}
                      onChange={handleInputChange}
                      label="Hide"
                      className="mb-0"
                    />
                  </div>
                  <Form.Control
                    type="text"
                    name="motherFullName"
                    value={editItem.motherFullName || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formmotherContactNumber">
                  <Form.Label>Contact Number 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                      </Form.Label>
                  <Form.Control
                    type="text"
                    name="motherContactNumber"
                    value={editItem.motherContactNumber || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    maxLength={10}
                    minLength={10}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formmotherEmail">
                  <Form.Label>Email ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="motherEmail"
                    value={editItem.motherEmail || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="formmotherOccupation">
                  <Form.Label>Occupation 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="motherOccupation"
                    value={editItem.motherOccupation || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formmotherAadhaarNo">
                  <Form.Label>Aadhaar No 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="motherAadhaarNo"
                    value={editItem.motherAadhaarNo || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {   // allows only digits
                        handleInputChange(e);
                      }
                    }}
                    maxLength={12}
                    minLength={12}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="formmotherHighestQualification">
                  <Form.Label>Highest Qualification 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Form.Label>
                  <Form.Control
                    type="text"
                    name="motherHighestQualification"
                    value={editItem.motherHighestQualification || ""}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              {/* Guardian Details */}

              <table className="table table-bordered mt-4">
                <tbody>
                  <tr>
                    <td
                      colSpan={8}
                      className="text-start fw-bold text-white"
                      style={{ backgroundColor: "black" }}
                    >
                      <h4>Guardian Details</h4>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Row className="mb-3">

                {/* Guardian Full Name */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianFullName">
                    <Form.Label>
                      Guardian's Full Name 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="guardianFullName"
                      value={editItem.guardianFullName || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                {/* Guardian Contact Number */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianContactNumber">
                    <Form.Label>
                      Contact Number 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="guardianContactNumber"
                      value={editItem.guardianContactNumber || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      maxLength={10}
                      minLength={10}
                    />
                  </Form.Group>
                </Col>

                {/* Guardian Email */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianEmail">
                    <Form.Label>Email ID</Form.Label>
                    <Form.Control
                      type="email"
                      name="guardianEmail"
                      value={editItem.guardianEmail || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                {/* Guardian Occupation */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianOccupation">
                    <Form.Label>
                      Occupation 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="guardianOccupation"
                      value={editItem.guardianOccupation || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                {/* Guardian Aadhaar */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianAadhaarNo">
                    <Form.Label>
                      Aadhaar No 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="guardianAadhaarNo"
                      value={editItem.guardianAadhaarNo || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      maxLength={12}
                      minLength={12}
                    />
                  </Form.Group>
                </Col>

                {/* Guardian Highest Qualification */}
                <Col md={2}>
                  <Form.Group controlId="formGuardianHighestQualification">
                    <Form.Label>
                      Highest Qualification 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="guardianHighestQualification"
                      value={editItem.guardianHighestQualification || ""}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Row>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EditPersonalDetailsModal;
